// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_i7-0";
export var fileCarousel = "_i7-2";
export var removeFileButton = "_i7-1";